import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DataTable from '../components/ResponsiveDataTable';
import { toast } from 'react-toastify';
import { apiCall, API_BASE_URL } from '../config/api';
import useIsMobile from '../hooks/useIsMobile';

const B2BConfig = () => {
  const isMobile = useIsMobile();
  const [whitelist, setWhitelist] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAddPhoneModal, setShowAddPhoneModal] = useState(false);
  const [newPhone, setNewPhone] = useState('');

  useEffect(() => {
    loadWhitelist();
  }, []);

  const loadWhitelist = async () => {
    setLoading(true);
    try {
      const res = await apiCall(`${API_BASE_URL}/b2b/oms/whitelist`);
      if (res.success) setWhitelist(res.data || []);
    } catch (err) { toast.error('Failed to load whitelist'); }
    finally { setLoading(false); }
  };

  const handleAddPhone = async () => {
    if (!newPhone || !/^[6-9]\d{9}$/.test(newPhone)) {
      toast.error('Enter a valid 10-digit phone number');
      return;
    }
    try {
      const res = await apiCall(`${API_BASE_URL}/b2b/oms/whitelist/add`, {
        method: 'POST', body: JSON.stringify({ phone: newPhone })
      });
      if (res.success) {
        toast.success('Phone added to whitelist');
        setNewPhone('');
        setShowAddPhoneModal(false);
        loadWhitelist();
      } else {
        toast.error(res.message || 'Failed to add');
      }
    } catch (err) { toast.error(err.message || 'Failed to add phone'); }
  };

  const handleRemovePhone = async (phone) => {
    if (!window.confirm(`Remove ${phone} from whitelist?`)) return;
    try {
      const res = await apiCall(`${API_BASE_URL}/b2b/oms/whitelist/remove`, {
        method: 'POST', body: JSON.stringify({ phone })
      });
      if (res.success) { toast.success('Phone removed'); loadWhitelist(); }
      else toast.error(res.message || 'Failed');
    } catch (err) { toast.error('Failed to remove'); }
  };

  const formatDate = (d) => d ? new Date(d).toLocaleDateString('en-IN') : 'N/A';

  const columns = [
    { name: 'Phone', selector: row => row.phone, sortable: true, width: '150px' },
    { name: 'Added By', selector: row => row.added_by, sortable: true, width: '200px' },
    { name: 'Added On', selector: row => row.created_at, sortable: true, format: row => formatDate(row.created_at), width: '150px' },
    { name: 'Last B2B Order', selector: row => row.last_b2b_order_date, format: row => formatDate(row.last_b2b_order_date), width: '150px' },
    { name: 'Actions', cell: row => (
      <button className="btn btn-danger" style={{ fontSize: isMobile ? '13px' : '12px', padding: isMobile ? '8px 12px' : '4px 8px' }} onClick={() => handleRemovePhone(row.phone)}>Remove</button>
    ), width: '100px' }
  ];

  return (
    <div className="container">
      <div className="card">
        <div className="order-detail-header">
          <div className="order-detail-title">
            <div className="breadcrumb"><Link to="/orders">Dashboard</Link> / B2B Whitelist</div>
            <h1>B2B Whitelisted Numbers</h1>
          </div>
          <div className="order-actions">
            <button className="btn btn-success" onClick={() => setShowAddPhoneModal(true)}>+ Add Number</button>
          </div>
        </div>

        <div className="card">
          <DataTable columns={columns} data={whitelist} pagination paginationPerPage={20} progressPending={loading} highlightOnHover striped noDataComponent="No whitelisted numbers" />
        </div>
      </div>

      {/* Add Phone Modal */}
      {showAddPhoneModal && (
        <div className="modal-overlay" onClick={() => setShowAddPhoneModal(false)}>
          <div className="modal-content" onClick={e => e.stopPropagation()} style={{ maxWidth: '400px' }}>
            <div className="modal-header"><h3>Add Phone to Whitelist</h3><button className="modal-close" onClick={() => setShowAddPhoneModal(false)}>×</button></div>
            <div className="modal-body">
              <div className="info-item">
                <label className="info-label">Phone Number</label>
                <input type="tel" inputMode="tel" autoComplete="tel" className="form-control" value={newPhone} onChange={e => setNewPhone(e.target.value)} placeholder="10-digit phone" maxLength="10" />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowAddPhoneModal(false)}>Cancel</button>
              <button className="btn btn-success" onClick={handleAddPhone}>Add</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default B2BConfig;
